export default __webpack_public_path__ + "static/img-stone-crab-500x325-4caefc17339c753a8e72f64ae5a18d09.png";